export const RESET = 'COMPANY_LIST_RESET'
export const SET_ITEMS = 'COMPANY_LIST_SET_ITEMS'
export const SET_ERROR = 'COMPANY_LIST_SET_ERROR'
export const SET_VIEW = 'COMPANY_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'COMPANY_LIST_TOGGLE_LOADING'
